"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormPersonTitle = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _server = require("@whitbread-eos/utils/server");
var _react = _interopRequireDefault(require("react"));
var _FormSelect = require("../FormSelect");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["disabled", "icons", "titleOptions"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var parseTitles = titles => {
  return titles.replace(/'/g, '').split(',').map(title => ({
    value: title,
    displayValue: title
  }));
};
var FormPersonTitle = exports.FormPersonTitle = _react.default.forwardRef((_ref, ref) => {
  var {
      disabled = false,
      icons,
      titleOptions
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var {
    t
  } = (0, _server.useTranslation)('users');
  return (0, _jsxRuntime.jsx)(_FormSelect.FormSelect, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    disabled: disabled,
    errorIcon: (0, _server.formatIBAssetsUrl)(icons === null || icons === void 0 ? void 0 : icons['icon.notification.error']),
    arrowIcon: (0, _server.formatIBAssetsUrl)(icons === null || icons === void 0 ? void 0 : icons['icon.chevron.down']),
    className: "w-[8.7rem]",
    options: parseTitles(titleOptions !== null && titleOptions !== void 0 ? titleOptions : t('userMgmt.employee.add.form.nameTitles'))
  }));
});
FormPersonTitle.displayName = 'FormPersonTitle';